import Image from 'next/image';
import React from 'react';
import { styled } from '@linaria/react';
import { CHOTOT_LOGO, JOB_LOGO, PTY_LOGO, VEH_LOGO } from '~/constants';
import config from '~/config';
const Logos = () => <Wrapper>
    <p>Được phát triển bởi</p>
    <div>
      <a href={config.baseUrl} target="_blank" id="chotot-link">
        <Image src={CHOTOT_LOGO} alt="Chotot Logo" height={21.5} width={60} />
      </a>
      <a href={config.ptyBaseUrl} target="_blank" id="nhatot-link">
        <Image src={PTY_LOGO} alt="Nhatot Logo" height={20} width={90} />
      </a>
      <a href={config.jobBaseUrl} target="_blank" id="vieclamtot-link">
        <Image src={JOB_LOGO} alt="Vieclamtot Logo" height={20} width={68} />
      </a>
      <a className="veh-link" href={config.vehBaseUrl} target="_blank" id="chototxe-link">
        <Image src={VEH_LOGO} alt="Chotot Xe Logo" height={93} width={93} />
      </a>
    </div>
  </Wrapper>;
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "wzjkpvr",
  propsAsIs: false
});
export default Logos;

require("./Logos.linaria.module.css");